//@ts-nocheck
import { useState, useContext, useEffect } from "react";
import InputForm from "../../Components/InputForm/InputForm";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import {
  CommonDropdownData,
  loanModuleGetPersonalDetailsByMemberId,
  postLoanDetails,
} from "../../Helpers/APIEndPoints/EndPoints";
import { Encrypt, Decrypt } from "../../Helpers/Cryptography/Crypto";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { useSelector } from "react-redux";
import { GenericMasterType, LoanTypeEnum } from "../../Helpers/Enums/Enum";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";

const LALoanDetails = (props) => {
  const [error, setError] = useState<any>({});
  const [disabled, setDisabled] = useState(false);
  const [disabledReason, setDisabledReason] = useState(false);
  const [reason, setReason] = useState({});
  const [reasonOption, setReasonOption] = useState([]);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [loanAmount, setLoanAmount] = useState();
  const [approvalStatus, setApprovalStatus] = useState();
  const [installments, setInstallments] = useState();
  const [loanRequestId, setLoanRequestId] = useState();
  const [formErrors, setFormErrors] = useState({});
  const context = getContext();
  let MemberId = context.MemberId;
  let navigate = useNavigate();
  let formErrorObj = {};
  let { selectNextTab, mode } = props;
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [formDataOnEdit, setFormDataOnEdit] = useState<any>();
  const [AdditionalLoanAmount, setAdditionalLoanAmount] = useState<any>();
  const [AdditionalLoanROI, setAdditionalLoanROI] = useState<any>();
  const [AdditionalAmountByIntTeam, setAdditionalAmountByIntTeam] = useState<any>();
  const [LongLoanROI, setLongLoanROI] = useState<any>();
  const [loanType, setLoanType] = useState<any>();
  const [AdditionalGiveableLoanAmount, setAdditionalGiveableLoanAmount] = useState<any>();
  const [givenableLoanAmount, setGiveableLoanAmount] = useState();
  const loanParameters = useSelector<any>(
    (state) => state?.LoanModuleReducer?.loanParameters
  );
  const [isResetClicked, setIsResetClicked] = useState<any>(false);

  useEffect(() => {
    // localStorage.setItem("Loa nRequestId", "");
    getPersonalDetailsByIdApiCallll();
    if (isResetClicked) {
      getDropDownDataApiCall();
    }
  }, [isResetClicked]);

  useEffect(() => {
    if (reasonOption.length > 0 && formDataOnEdit != "") {
      let val = reasonOption.find((ele) => ele.value == formDataOnEdit);
      setReason(val);
    }
  }, [reasonOption, formDataOnEdit]);

  // const onChange = (key: any, value: any) => {
  //   if (key == "loanAmount") {
  //     setLoanAmount(value);
  //   }
  //   if (key == "installments") {
  //     setInstallments(value);
  //   }
  // };

  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "reason") {
      setReason(event);
    }
  };

  const getDropDownDataApiCall = async () => {
    showLoader();
    let requestParams = {
      dropdownName: "generic",
      GenericMasterTypeId:
        loanType == LoanTypeEnum.SHORTTERM
          ? GenericMasterType.SHORTTERM
          : GenericMasterType.LONGTERM, // short term
    };
    //
    const res = await APICall(CommonDropdownData, requestParams);

    if (res && res?.Data?.length > 0) {
      let options = res.Data;
      setReasonOption(options);
      hideLoader();
    } else {
      setReasonOption([]);
      notify(ToastType.Error, res.Message);
      hideLoader();
    }
  };

  const onSubmitValidation = async () => {
    setFormErrors({});
    formErrorObj = {};

    // if (!loanAmount || loanAmount === "" || loanAmount >= 0) {
    //   formErrorObj["loanAmount_isEmpty"] =
    //     "Loan amount can not be empty or Zero(0)";
    // }
    if (!reason || Object.keys(reason).length <= 0) {
      formErrorObj["reason_isEmpty"] = "Please select reason";
    }
    // if (!installments || installments === "" || installments <= 0) {
    //   formErrorObj["installments_isEmpty"] =
    //     "Installments can not be empty or Zero(0)";
    // } else if (installments >= 96) {
    //   formErrorObj["installments_isEmpty"] =
    //     "Installments should be less than Max 96 Months";
    // }

    setFormErrors(formErrorObj);
  };

  const handleKeyPress = (event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  const getPersonalDetailsByIdApiCallll = async () => {
    showLoader();
    let requestParams = loanParameters; // { MemberId: MemberId };
    const res = await APICall(
      loanModuleGetPersonalDetailsByMemberId,
      requestParams
    );
    if (res.Message === "Ok" && res.Data !== null) {
     
      if (
        res?.Data?.Lrd_LoanAmount != 0 &&
        res?.Data?.Lrd_InstallmentPeriod != 0
      ) {
        setLoanRequestId(res?.Data?.Lrd_Id);
        // localStorage.setItem(
        //   "Lo anRequestId",
        //   Encrypt(JSON.stringify(res?.Data?.Lrd_Id))
        // );
        localStorage.setItem(
          "LoanType",
          Encrypt(JSON.stringify(res?.Data?.Lrd_LoanType))
        );

        setApprovalStatus(res?.Data?.Lrd_StatusId);
        if (
          [
            LoanStatus.LoanModule_RejectedByInternalTeam,
            LoanStatus.LoanModule_Draft,
          ].includes(res?.Data?.Lrd_StatusId)
        ) {
          if (context?.CurrentRoleId === RoleEnum.Member) {
            setDisabledReason(false);
          } else {
            setDisabledReason(true);
          }
        } else if (
          [
            LoanStatus.LoanModule_AllSuretyApproved,
            LoanStatus.LoanModule_PendingMemberLoanConfirmation,
            LoanStatus.LoanModule_PendingWithInternalTeam,
            LoanStatus.LoanModule_LoanApplicationCancelledByMember,
            LoanStatus.LoanModule_LoanApplicationRejected,
            LoanStatus.LoanModule_LoanAgreementPending,
            LoanStatus.LoanModule_SuretyApprovalPending,
            LoanStatus.LoanModule_MemberSignaturePending,
            LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
            LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            LoanStatus.LoanModule_LoanCommitteeApprovalPending,
            LoanStatus.LoanModule_MemberAgreementRejected,
            LoanStatus.LoanModule_LoanFinalApprovalPending,
            LoanStatus.LoanModule_DocumentGenerationPending,
            LoanStatus.LoanModule_LoanApplicationApproved,
            LoanStatus.LoanModule_LoanCompleted,
          ].includes(res?.Data?.Lrd_StatusId)
        ) {
          setDisabledReason(true);
        }
        setIsResetClicked(true);
        setDisabled(true);
        setButtonDisabled(true);
        setLoanAmount(res?.Data?.Lrd_LoanAmount);
        setLoanType(res?.Data?.Lrd_LoanType);
        setInstallments(res?.Data?.Lrd_InstallmentPeriod); //
        setFormDataOnEdit(res?.Data?.Lrd_Reason);
        if (res?.Data?.Lrd_LoanType === LoanTypeEnum.LONGTERM) {
          setLongLoanROI(res?.Data?.LtlRoi);
        } else {
          setLongLoanROI(res?.Data?.RateOfInterest);
        }
        setAdditionalLoanAmount(res?.Data?.Lrd_AdditionalLoanAmount);
        setAdditionalLoanROI(res?.Data?.AltlRoi);
        setAdditionalAmountByIntTeam(res?.Data?.Lrd_AdditionalAmountByIntTeam);
        setAdditionalGiveableLoanAmount(res?.Data?.Lrd_AdditionalGiveableLoanAmount);
        setGiveableLoanAmount(res?.Data?.Lrd_GiveableLoanAmount);
      }
      hideLoader();
    } else {
      notify(1, "Data not found");
      hideLoader();
    }
  };

  const onSubmit = async () => {
    await onSubmitValidation();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });

    if (isEmpty === true) {
      if (disabledReason) {
        await selectNextTab();
        return;
      }
      showLoader();

      let param = {
        LoanId: loanRequestId,
        MemberId: MemberId,
        StatusId:
          approvalStatus == LoanStatus.LoanModule_RejectedByInternalTeam
            ? LoanStatus.LoanModule_RejectedByInternalTeam
            : LoanStatus.LoanModule_Draft,
        LoanAmount: loanAmount.toString().replace(/,/g, ""),
        Reason: reason?.value,
        InstallmentPeriod: installments,
        ModifiedBy: context.Id,
      };

      const insertData = await APICall(postLoanDetails, param);
      if (insertData?.Data) {
        // notify(ToastType.Success, "Successfully data inserted");
        await selectNextTab();
        hideLoader();
      } else {
        notify(
          ToastType.Error,
          insertData?.Message ||
          "Failed to upload document, Please try again later."
        );
        hideLoader();
        return;
      }
    }
    hideLoader();
  };

  return (
    <div className="p-0">
      <div className="col-lg-12 col-md-12">
        <div
          className="row"
          style={{ marginLeft: "-30px", marginRight: "-30px" }}
        >
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group">
              <label>{loanType === LoanTypeEnum.LONGTERM ? "Long" : "Short"} Term Loan Amount</label>
              <sup style={{ fontSize: "13px" }}>*</sup>
              <InputForm
                placeholder={"Enter Loan Amount"}
                // value={loanAmount}
                value={(loanAmount || 0).toLocaleString("en-IN")}
                isDisabled={disabled}
              />
              {/* <p style={{ color: "red" }}>{formErrors["loanAmount_isEmpty"]}</p> */}
            </div>
          </div>
          {loanType === LoanTypeEnum.LONGTERM && (
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Total Sanction Amount</label>
                {/* <label>Additional Loan Amount</label> */}
                <sup>*</sup>
                <InputForm
                  placeholder={""}  
                  // value={AdditionalAmountByIntTeam}
                   value={(
                      AdditionalAmountByIntTeam 
                    ).toLocaleString("en-IN")}
                 // type="number"
                  isDisabled={true}
                />
                <p style={{ color: "red" }}>
                  {formErrors["additionalAmount_isEmpty"]}
                </p>
              </div>
            </div>
          )}
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group">
              <label>{loanType === LoanTypeEnum.LONGTERM ? "Long" : "Short"} Term ROI (%)</label>
              <InputForm
                placeholder={""}
                value={LongLoanROI + " %"}
                isDisabled={true}
              />
            </div>
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group">
              <label>Period of Installments</label>
              <sup style={{ fontSize: "13px" }}>*</sup>
              <InputForm
                placeholder={"Period of Installments"}
                value={installments + " Months"}
                // onChange={(val: any) => {
                //   let value = val.target.value.replace(/[^0-9]/g, "");
                //   if (value <= 96) {
                //     onChange("installments", value);
                //   }
                // }}
                // onKeyPress={(e) => handleKeyPress(e)}
                // maxlength={2}
                isDisabled={disabled}
              />
              <p style={{ color: "red" }}>
                {formErrors["installments_isEmpty"]}
              </p>
            </div>
          </div>

          {loanType == LoanTypeEnum.LONGTERM && (
            <>
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group">
                  <label>Additional Long Term Amount</label>
                  <InputForm
                    placeholder={""}
                    value={AdditionalLoanAmount?.toLocaleString("en-IN")}
                    isDisabled={true}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group">
                  <label>Additional Long Term ROI (%)</label>
                  <InputForm
                    placeholder={""}
                    value={AdditionalLoanROI + " %"}
                    isDisabled={true}
                  />
                </div>
              </div>
            </>
          )}
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group">
              <label>Reason</label>
              <sup style={{ fontSize: "13px" }}>*</sup>
              <SelectForm
                options={reasonOption}
                isMulti={false}
                placeholder={""}
                value={reason}
                onChange={(event: any) => selectOnChange(event, "reason")}
                isDisabled={disabledReason}
              />
              <p style={{ color: "red" }}>{formErrors["reason_isEmpty"]}</p>
            </div>
          </div>
          {loanType == LoanTypeEnum.LONGTERM && (
            <>
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group">
                  <label>Total Giveable Amount</label>
                  <InputForm
                    placeholder={""}
                    value={(
                      (parseInt(givenableLoanAmount) || 0) +
                      (parseInt(AdditionalGiveableLoanAmount) || 0)
                    ).toLocaleString("en-IN")}
                    isDisabled={true}
                  />
                </div>
              </div>
              {/* <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group">
              <label>Additional Long Term Giveable Amount</label>
              <InputForm
                placeholder={""}
                value={AdditionalGiveableLoanAmount?.toString().replace(
                  /(\d)(?=(\d{2})+\d(?!\d))/g,
                  "$1,"
                )}
                isDisabled={true}
              />
            </div>
          </div> */}
            </>
          )}
        </div>
      </div>

      {[
        LoanStatus.LoanModule_Draft,
        LoanStatus.LoanModule_RejectedByInternalTeam,
      ].includes(approvalStatus) &&
        context?.CurrentRoleId === RoleEnum.Member && (
          <div>
            <div
              className="p-2 d-flex justify-content-end"
              style={{ marginTop: 50 }}
            >
              <ButtonComponent
                icon={""}
                value={
                  <p>
                    <i className="far fa-times-circle"></i> Cancel
                  </p>
                }
                style={{ marginLeft: "10px" }}
                className="btn btn-primary"
                onClick={() => navigate("/LoanApprovalDashboard")}
              />
              <ButtonComponent
                icon={"fas fa-arrow-right"}
                value={buttonDisabled ? "Save & Next" : "Next"}
                style={{ marginLeft: "10px" }}
                id={"saveBtn"}
                onClick={onSubmit}
              />
            </div>
          </div>
        )}
    </div>
  );
};

export default LALoanDetails;
